/* ---- tabs: the global .segmented control, spaced from the panel ------------- */
.tabs {
  margin-bottom: var(--sp-8);
}

/* ---- panel ---------------------------------------------------------------- */
.panel {
  display: grid;
  gap: var(--sp-8);
}
@media (min-width: 64rem) {
  .panel {
    grid-template-columns: minmax(0, 7fr) minmax(0, 5fr);
    align-items: center;
    gap: var(--sp-16);
  }
}

/* ---- text ----------------------------------------------------------------- */
.text {
  display: grid;
  justify-items: start;
  gap: var(--sp-4);
}
.title {
  font-size: clamp(var(--fs-xl), 1rem + 1.2vw, var(--fs-3xl));
  line-height: var(--lh-tight);
  letter-spacing: var(--tracking-heading);
  text-wrap: balance;
}
.lead {
  margin: 0;
  font-size: var(--fs-md);
}
/* A spec sheet: hairline rows, no bullets. */
.points {
  align-self: stretch;
  margin: var(--sp-2) 0 0;
}
.points li {
  padding-block: var(--sp-3);
  border-top: 1px solid var(--border);
  color: var(--text-strong);
}
.points li:last-child {
  border-bottom: 1px solid var(--border);
}
.cta {
  margin-top: var(--sp-4);
}
